// import XLSX from "xlsx";
import BaseCommand from "./baseCommand";

class UpdateXlsToTableCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    const {
      payload,
      toggleTabAndToolPanelData,
      convertSectionTableToLinkedExcel,
      saveTable,
      isChangingFileForSameTable,
    } = this.componentData;

    // Switching tabs
    const { oldSection, tableType, uploadedExcelData } = payload;

    const tableData = convertSectionTableToLinkedExcel(
      oldSection,
      uploadedExcelData,
      isChangingFileForSameTable,
    );
    saveTable(tableData);

    if (!isChangingFileForSameTable) {
      toggleTabAndToolPanelData({
        tabView: tableData.attributes.label,
        isOpen: true,
        panelView: "excel-catalog",
        page: tableType,
        tabViewType: tableType,
        excelSheetId: oldSection.id,
      });
    }
  }

  // undo() {
  //   const { toggleComponentLockUnlock, payload } = this.componentData;
  //   if (payload) {
  //     this.scrollIntoView(payload.activeComponentID);
  //   }
  //   const newPayload = { ...payload };
  //   newPayload.lockStatus = !payload.lockStatus;
  //   toggleComponentLockUnlock(newPayload);
  // }
}

export default UpdateXlsToTableCommand;
